module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture34-83ff1d451aa313f5231c76c8c0ce6fe0.jpg";